import React, { memo } from "react";
import clsx from "clsx";
import styles from "./AddToBasket.module.scss";
import Icon from "../../../../shared-components/css-modules/toyota/atoms/Icon";
import { useCarConfigLabel } from "../../../utils/labelUtils";

export type Props = {
    className?: string;
    active: boolean;
    itemName: string;
    checkType?: boolean;
} & React.HTMLProps<HTMLButtonElement>;

const AddToBasket: React.FC<Props> = ({
    active,
    className,
    checkType,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    type = "button",
    itemName = "item",
    ...rest
}) => {
    const addtoBasketAriaLabel = useCarConfigLabel("carConfigA11yButtonAddToBasket", { item: itemName });
    const removeFromBasketAriaLabel = useCarConfigLabel("carConfigA11yButtonRemoveFromBasket", { item: itemName });

    const label = active ? removeFromBasketAriaLabel : addtoBasketAriaLabel;

    return (
        <button
            type="button"
            aria-pressed={active}
            className={clsx(styles.button, active && styles.active, className)}
            aria-label={label}
            {...rest}
        >
            {active ? (
                checkType ? (
                    <Icon variant="check" sizing="xs" aria-hidden="true" />
                ) : (
                    <Icon variant="minus" sizing="sm" aria-hidden="true" />
                )
            ) : (
                <Icon variant="plus" sizing="xs" aria-hidden="true" />
            )}
        </button>
    );
};

export default memo(AddToBasket);
